import {Component, Input, OnInit} from '@angular/core';
import {AnnualReportData, AnnualReportInput} from '../../../_models/financial-management.model';
import {FinancialManagementService} from '../../../_services/financial-management.service';
import {MessageService} from "primeng/api";

@Component({
    selector: 'acabim-admin-fund-table',
    templateUrl: './fund-table.component.html',
    styleUrls: ['./fund-table.component.scss']
})
export class FundTableComponent implements OnInit {
    isLoading = false;
    public backupDS: AnnualReportData[] = [];
    public dataSources: AnnualReportData[] = [];
    projectId?: string;
    accountId?: string;
    accountName?: string;
    currentYear: number = (new Date()).getFullYear();
    fromYear: { name: number }[] = [];
    toYear: { name: number }[] = [];
    range = {before: 20, after: 50};
    yearBefore?: { name: number };
    yearAfter?: { name: number };

    @Input() set accountInfo(value: { projectId: string, accountId: string, accountName: string }) {
        this.projectId = value.projectId;
        this.accountId = value.accountId;
        this.accountName = value.accountName;
        // this.financialService.getAccountReport(value.accountId, value.projectId,)
        this.fromYear = [];
        this.toYear = [];
        for (let i = this.range.before; i > 0; i--) {
            this.fromYear.push({name: this.currentYear - i});
        }
        for (let i = 0; i <= this.range.after; i++) {
            this.toYear.push({name: this.currentYear + i});
        }

        this.yearBefore = this.fromYear.filter(x => x.name === this.currentYear - 3)[0];
        this.yearAfter = this.toYear.filter(x => x.name === this.currentYear + 15)[0];
        // @ts-ignore
        this.refreshFundList(value.projectId, value.accountId, this.yearBefore.name, this.yearAfter.name);
    }

    refreshFundList(projectId: string, accountId: string, yearBefore: number, yearAfter: number) {
        this.isLoading = true;
        this.financialService.getAccountReport(accountId, projectId, yearBefore, yearAfter).subscribe(data => {
            this.dataSources = [...data.slice()];
            this.backupDS = JSON.parse(JSON.stringify(data.slice()));
            this.isLoading = false;
        });
    }

    constructor(private readonly financialService: FinancialManagementService,
                private readonly messageService: MessageService
    ) {
    }

    ngOnInit(): void {
    }

    refreshList(): void {
        if (this.projectId && this.accountId && this.yearBefore?.name && this.yearAfter?.name) {
            if (this.yearAfter?.name - this.yearBefore?.name <= 20) {
                this.refreshFundList(this.projectId, this.accountId, this.yearBefore.name, this.yearAfter.name);
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    detail: 'Cannot have more than 25 years'
                });
            }
        }
    }

    toggleEdit(record: AnnualReportData): void {
        this.dataSources.filter(x => x.year === record.year)[0].edit = true;
    }

    closeEdit(record: AnnualReportData): void {
        this.dataSources.filter(x => x.year === record.year)[0].edit = false;
        if (this.backupDS && this.backupDS.length > 0) {
            this.dataSources = JSON.parse(JSON.stringify(this.backupDS.slice()));
        }
    }

    saveState(record: any): void {
        this.isLoading = true;
        const serviceBody: AnnualReportInput = {
            balance: record.balance,
            expense_budget: record.expense_budget,
            expense_actual: record.expense_actual,
            income_budget: record.income_budget,
            income_actual: record.income_actual
        };
        if (this.projectId && this.accountId) {
            this.financialService.updateAccountData(serviceBody, record.year, this.accountId, this.projectId).subscribe(data => {
                if (this.projectId && this.accountId && this.yearBefore?.name && this.yearAfter?.name) {

                    this.refreshFundList(this.projectId, this.accountId, this.yearBefore.name, this.yearAfter.name);
                }
            });
        }

    }
}
